const MENU_LAYOUT_ID_EXTENDED = 2;

export function mapperProduct(product) {
  const { images, legacyId, id, tags, price, ...oldProduct } = product;
  const { urls, isCustomized } = images || {};
  const { finalPrice, originalPrice, discount, finalPriceWithoutTaxes = null } =
    price || {};
  const { foodCategories, requiresAgeCheck, isFavourite } = tags || {};
  const [firstImage] = urls || [];
  const [firstCategory] = foodCategories || [];
  let subsidizedProduct = null;
  let discountProduct = null;

  if (originalPrice) {
    subsidizedProduct = {
      endDate: '',
      id: legacyId || id,
      originalPrice,
      price: finalPrice,
      startDate: '',
    };
  }

  if (discount && discount.percentage > 0) {
    discountProduct = discount.percentage;
  }

  return {
    ...oldProduct,
    requiresAgeCheck,
    isFavourite,
    subsidizedProduct,
    enabled: true,
    image: firstImage || product.image || '',
    hasCustomPhoto: isCustomized,
    applyDiscount: false,
    itemId: product.itemId || id,
    id: legacyId || id,
    foodCategoryTag: firstCategory ? { name: firstCategory } : null,
    price: finalPrice,
    discount: discountProduct,
    quantity: 0,
    finalPriceWithoutTaxes,
  };
}

export function mapperSection(section) {
  const { images, products, ...oldSection } = section;
  const [firstImage] = images || [];
  return {
    ...oldSection,
    enabled: true,
    image: firstImage || '',
    products: products.map(mapperProduct),
  };
}

function mapperV2(response) {
  try {
    const { legacyId, sections, ...oldMenu } = response;
    return {
      ...oldMenu,
      id: legacyId,
      layout: MENU_LAYOUT_ID_EXTENDED,
      sections: sections.map(mapperSection),
    };
  } catch (err) {
    throw new Error(`Error parsing niles menu V2, ${err?.message || ''}`);
  }
}

export default mapperV2;
